import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useMaxVariants() {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, { maxProductVariants: number }>({
    method: RequestMethodsEnum.get,
  })

  const { data: maxVariants } = useSWR(
    () => user && '/api/dashboard/customer/max-product-variants',
    fetcher,
  )

  return { maxVariants }
}
